import _ from 'lodash';

export const isFieldEmptyOrUndefined = (field: string | string[] | undefined) => {
  return _.isUndefined(field) || _.isEmpty(field);
};
